
export const de = {
  nav: {
    home: 'Startseite',
    about: 'Über uns',
    services: 'Dienstleistungen',
    blog: 'Blog',
    contact: 'Kontakt',
    language: 'Sprache'
  },
  header: {
    search: 'Suchen...',
    login: 'Anmelden',
    register: 'Registrieren',
    logout: 'Abmelden',
    account: 'Konto'
  },
  auth: {
    login: 'Anmelden',
    register: 'Registrieren',
    fullName: 'Vollständiger Name',
    email: 'E-Mail',
    password: 'Passwort',
    confirmPassword: 'Passwort bestätigen',
    enterFullName: 'Geben Sie Ihren vollständigen Namen ein',
    enterEmail: 'Geben Sie Ihre E-Mail-Adresse ein',
    enterPassword: 'Geben Sie Ihr Passwort ein',
    confirmPasswordPlaceholder: 'Bestätigen Sie Ihr Passwort',
    loginButton: 'Anmelden',
    registerButton: 'Registrieren',
    processing: 'Verarbeitung...',
    noAccount: 'Haben Sie kein Konto?',
    hasAccount: 'Haben Sie bereits ein Konto?',
    loginLink: 'Anmelden',
    registerLink: 'Registrieren',
    passwordMismatch: 'Passwörter stimmen nicht überein',
    passwordTooShort: 'Passwort muss mindestens 6 Zeichen lang sein',
    invalidCredentials: 'Ungültige E-Mail oder Passwort',
    emailExists: 'Diese E-Mail-Adresse wird bereits verwendet',
    generalError: 'Ein Fehler ist aufgetreten, bitte versuchen Sie es erneut'
  },
  hero: {
    title: 'Fördern Sie Ihre Karriere mit professionellen Zertifikaten',
    subtitle: 'Erhalten Sie international anerkannte Zertifikate mit IQCERT und machen Sie einen Unterschied in der Geschäftswelt. Erreichen Sie Erfolg mit unseren Expertentrainern und hochwertigen Trainingsprogrammen.',
    cta: 'Zertifikate durchsuchen',
    watchVideo: 'Intro-Video ansehen'
  },
  "nav.home": "Startseite",
  "nav.about": "Über uns",
  "nav.services": "Dienstleistungen",
  "nav.blog": "Blog",
  "nav.contact": "Kontakt",
  "nav.language": "Sprache",
  "hero.title": "Professionelle Zertifikatsausbildung",
  "hero.subtitle": "Erhalten Sie die Zertifikate, die Sie für Ihre Karriere benötigen",
  "hero.description": "Entwickeln Sie Ihre Fähigkeiten mit Online-Zertifikatsprogrammen von Experten und machen Sie den Unterschied in Ihrer Karriere.",
  "hero.cta": "Kurse Entdecken",
  "hero.watch": "Intro-Video Ansehen",
  "services.title": "Zertifikatsprogramme",
  "services.subtitle": "Qualitätsschulungen von Experten-Ausbildern in ihrem Bereich",
  "services.it.title": "Informationstechnologien",
  "services.it.description": "Professionelle Zertifikatsprogramme in Softwareentwicklung, Datenanalyse und Cybersicherheit.",
  "services.business.title": "Unternehmensführung",
  "services.business.description": "Zertifikatsprogramme von Experten-Ausbildern in Projektmanagement, Führung und Geschäftsentwicklung.",
  "services.design.title": "Design und Kreativität",
  "services.design.description": "Kreative Zertifikatsprogramme in Grafikdesign, UI/UX und digitalem Marketing.",
  "services.language.title": "Sprachausbildung",
  "services.language.description": "International gültige Zertifikatsprogramme in Englisch, Deutsch und anderen Fremdsprachen",
  "about.title": "Warum uns wählen?",
  "about.subtitle": "Wir haben mit über 10 Jahren Erfahrung Tausenden von Studenten Zertifikate verliehen",
  "about.expert.title": "Experten-Ausbilder",
  "about.expert.description": "Erhalten Sie qualitativ hochwertige Bildung von erfahrenen und zertifizierten Ausbildern",
  "about.flexible.title": "Flexibles Lernen",
  "about.flexible.description": "Nehmen Sie in Ihrem eigenen Tempo teil, jederzeit und überall",
  "about.certificate.title": "Gültige Zertifikate",
  "about.certificate.description": "Stärken Sie Ihre Karriere mit international anerkannten Zertifikaten",
  "about.support.title": "24/7 Support",
  "about.support.description": "Wir sind immer bei Ihnen während Ihres Lernprozesses",
  "about.tagline": "IQCERT Zertifizierung",
  "about.certificates.badge": "International gültige Zertifikate",
  "about.certificates.badgeDesc": "ISO 9001, ISO 14001, HACCP, SCC und mehr",

  "blog.title": "Neueste Artikel",
  "blog.subtitle": "Aktuelle Inhalte über Bildung und Karriereentwicklung",
  "blog.readMore": "Weiterlesen",
  "blog.post1.title": "Die Bedeutung der Zertifikatsausbildung im digitalen Zeitalter",
  "blog.post1.excerpt": "In der heutigen sich schnell entwickelnden Technologie ist kontinuierliches Lernen und Selbstverbesserung kein Luxus mehr, sondern eine Notwendigkeit.",
  "blog.post1.author": "Dr. Mehmet Yılmaz",
  "blog.post1.date": "15. Dezember 2024",
  "blog.post1.category": "Bildung",
  "blog.post2.title": "Die Rolle von Zertifikaten in der Karriereentwicklung",
  "blog.post2.excerpt": "Welche Zertifikate sollten Sie erwerben, um sich in der Geschäftswelt hervorzuheben? Expertenrat und Erfolgsgeschichten.",
  "blog.post2.author": "Ayşe Demir",
  "blog.post2.date": "12. Dezember 2024",
  "blog.post2.category": "Karriere",
  "blog.post3.title": "10 Tipps für den Erfolg in der Online-Bildung",
  "blog.post3.excerpt": "Strategien und Empfehlungen, die Sie anwenden sollten, um maximale Effizienz aus Online-Schulungen zu erzielen.",
  "blog.post3.author": "Prof. Dr. Ali Kaya",
  "blog.post3.date": "10. Dezember 2024",
  "blog.post3.category": "Tipps",
  "news.title": "Nachrichten & Ankündigungen",
  "news.subtitle": "Neueste Nachrichten aus der Branche und wichtige Ankündigungen",
  "info.students": "Aktive Studenten",
  "info.courses": "Zertifikatsprogramme",
  "info.instructors": "Experten-Ausbilder",
  "info.satisfaction": "Zufriedenheitsrate",
  "footer.description": "Fördern Sie Ihre Karriere mit professioneller Zertifikatsausbildung",
  "footer.quickLinks": "Schnelle Links",
  "footer.programs": "Programme",
  "footer.support": "Support",
  "footer.contact": "Kontakt",
  "footer.phone": "Telefon",
  "footer.email": "E-Mail",
  "footer.address": "Adresse",
  "footer.rights": "Alle Rechte vorbehalten",
  "common.learnMore": "Mehr Erfahren",
  "common.getStarted": "Loslegen",
  "common.viewAll": "Alle Anzeigen",
  "common.loading": "Wird geladen...",
  "common.error": "Ein Fehler ist aufgetreten",
  "common.success": "Erfolgreich",
  "services.belgelendirme.title": "Zertifizierungsdienstleistungen",
  "services.belgelendirme.subtitle": "Nachhaltiger Tourismus, GSTC-Zertifikat, Personal- und Vegan-Zertifizierung",
  "services.belgelendirme.description": "Als IQCERT bieten wir Zertifizierungsdienstleistungen nach internationalen Standards in verschiedenen Branchen an. Wir arbeiten mit unserem Expertenteam in den Bereichen nachhaltiger Tourismus, Personalkompetenzen und spezielle Zertifizierungsbereiche.",
  "services.belgelendirme.sustainable": "Nachhaltiger Tourismus",
  "services.belgelendirme.gstc": "GSTC-Zertifikat",
  "services.belgelendirme.personnel": "Personalzertifizierung",
  "services.belgelendirme.vegan": "Vegan-Zertifizierung",
  "services.yonetim.title": "Managementsystem-Zertifizierung",
  "services.yonetim.subtitle": "ISO-Standards und Managementsystem-Zertifizierungsdienstleistungen",
  "services.yonetim.description": "Wir bieten Zertifizierungsdienstleistungen nach ISO-Standards in Bereichen wie Qualität, Umwelt, Arbeitsschutz und Energiemanagement an.",
  "services.yonetim.iso9001": "ISO 9001 Qualitätsmanagementsystem",
  "services.yonetim.iso14001": "ISO 14001 Umweltmanagementsystem",
  "services.yonetim.iso45001": "ISO 45001 Arbeitsschutz",
  "services.yonetim.iso50001": "ISO 50001 Energiemanagementsystem",
  "services.yonetim.iso10002": "ISO 10002 Kundenzufriedenheitsmanagement",
  "services.yonetim.iso27001": "ISO 27001 Informationssicherheitsmanagement",
  "services.yonetim.iso27701": "ISO 27701 Datenschutz",
  "services.yonetim.iso31000": "ISO 31000 Risikomanagementsystem",
  "services.yonetim.iso39001": "ISO 39001 Straßenverkehrssicherheit",
  "services.yonetim.iso28001": "ISO 28001 Lieferkettensicherheit",
  "services.yonetim.iso22301": "ISO 22301 Business Continuity Management",
  "iso.9001.description": "Qualitätsmanagementsystem-Standard, der die Kundenzufriedenheit erhöht",
  "iso.9001.benefits.1": "Erhöhte Kundenzufriedenheit",
  "iso.9001.benefits.2": "Prozesseffizienz",
  "iso.9001.benefits.3": "Reduzierung der Fehlerquoten",
  "iso.9001.benefits.4": "Kultur der kontinuierlichen Verbesserung",
  "iso.14001.description": "Managementsystem zur Minimierung von Umweltauswirkungen",
  "iso.14001.benefits.1": "Umweltrisiko-Reduzierung",
  "iso.14001.benefits.2": "Energieeinsparung",
  "iso.14001.benefits.3": "Abfallmanagement",
  "iso.14001.benefits.4": "Rechtliche Compliance",
  "iso.45001.description": "System zum Schutz der Gesundheit und Sicherheit der Mitarbeiter",
  "iso.45001.benefits.1": "Reduzierung von Arbeitsunfällen",
  "iso.45001.benefits.2": "Mitarbeitersicherheit",
  "iso.45001.benefits.3": "Risikobewertung",
  "iso.45001.benefits.4": "Erfüllung rechtlicher Verpflichtungen",
  "iso.50001.description": "Managementsystem zur Steigerung der Energieeffizienz",
  "iso.50001.benefits.1": "Reduzierung der Energiekosten",
  "iso.50001.benefits.2": "CO2-Fußabdruck-Reduzierung",
  "iso.50001.benefits.3": "Verbesserung der Energieleistung",
  "iso.50001.benefits.4": "Nachhaltigkeit",
  "iso.10002.description": "System für effektives Beschwerdemanagement",
  "iso.10002.benefits.1": "Erhöhte Kundenloyalität",
  "iso.10002.benefits.2": "Beschwerdeverfahren",
  "iso.10002.benefits.3": "Kundenfeedback",
  "iso.10002.benefits.4": "Verbesserung der Servicequalität",
  "iso.27001.description": "Schutz von Informationswerten und Sicherheitsmanagement",
  "iso.27001.benefits.1": "Datensicherheit",
  "iso.27001.benefits.2": "Schutz vor Cyberangriffen",
  "iso.27001.benefits.3": "Vertraulichkeitsgewährleistung",
  "iso.27001.benefits.4": "Rechtliche Compliance",
  "iso.27701.description": "DSGVO-konformes Datenschutzsystem",
  "iso.27701.benefits.1": "DSGVO-Compliance",
  "iso.27701.benefits.2": "Datenschutz",
  "iso.27701.benefits.3": "Datenschutzmanagement",
  "iso.27701.benefits.4": "Rechtliche Risikominderung",
  "iso.31000.description": "Systematisches Management von Unternehmensrisiken",
  "iso.31000.benefits.1": "Risikoidentifikation",
  "iso.31000.benefits.2": "Risikobewertung",
  "iso.31000.benefits.3": "Risikominderungsstrategien",
  "iso.31000.benefits.4": "Entscheidungsprozesse",
  "iso.39001.description": "Managementsystem zur Erhöhung der Verkehrssicherheit",
  "iso.39001.benefits.1": "Reduzierung von Verkehrsunfällen",
  "iso.39001.benefits.2": "Fahrersicherheit",
  "iso.39001.benefits.3": "Fuhrparkmanagement",
  "iso.39001.benefits.4": "Sicherheitskultur",
  "iso.28001.description": "Lieferketten-Sicherheitsmanagementsystem",
  "iso.28001.benefits.1": "Liefersicherheit",
  "iso.28001.benefits.2": "Logistiksicherheit",
  "iso.28001.benefits.3": "Risikomanagement",
  "iso.28001.benefits.4": "Betriebskontinuität",
  "iso.22301.description": "Managementsystem zur Gewährleistung der Geschäftskontinuität",
  "iso.22301.benefits.1": "Geschäftskontinuitätsplanung",
  "iso.22301.benefits.2": "Krisenmanagement",
  "iso.22301.benefits.3": "Betriebsresilienz",
  "iso.22301.benefits.4": "Schnelle Wiederherstellung",
  "implementation.title": "Implementierungsprozess",
  "implementation.subtitle": "Mit unserem systematischen Ansatz implementieren wir Ihre Managementsysteme erfolgreich",
  "implementation.step1.title": "Ist-Zustand-Analyse",
  "implementation.step1.description": "Bewertung des aktuellen Zustands der Organisation und Gap-Analyse",
  "implementation.step2.title": "Systemdesign",
  "implementation.step2.description": "Design des ISO-Standard-konformen Managementsystems",
  "implementation.step3.title": "Dokumentation",
  "implementation.step3.description": "Erstellung von Richtlinien, Verfahren und Anweisungen",
  "implementation.step4.title": "Schulung und Implementierung",
  "implementation.step4.description": "Personalschulung und Systemimplementierung",
  "implementation.step5.title": "Interne Auditierung",
  "implementation.step5.description": "Kontrolle der Systemwirksamkeit durch interne Audits",
  "implementation.step6.title": "Zertifizierungsaudit",
  "implementation.step6.description": "Zertifizierungsaudit durch unabhängige Organisation",
  "why.iso.title": "Warum ISO-Managementsysteme?",
  "why.iso.subtitle": "Steigern Sie die Leistung Ihrer Organisation mit ISO-Standards",
  "why.iso.recognition.title": "Internationale Anerkennung",
  "why.iso.recognition.description": "Gültige Zertifizierung in globalen Märkten",
  "why.iso.improvement.title": "Prozessverbesserung",
  "why.iso.improvement.description": "Steigerung der betrieblichen Effizienz",
  "why.iso.risk.title": "Risikomanagement",
  "why.iso.risk.description": "Proaktive Risikoidentifikation und -management",
  "why.iso.trust.title": "Kundenvertrauen",
  "why.iso.trust.description": "Erhöhte Kundenzufriedenheit und -loyalität",
  "cta.iso.title": "Starten Sie die ISO-Managementsystem-Implementierung",
  "cta.iso.description": "Unsere Expertenberater helfen Ihnen dabei, den am besten geeigneten ISO-Standard zu bestimmen und erfolgreich zu implementieren.",
  "cta.consultation": "Kostenlose Beratung",
  "cta.quote": "Angebot erhalten",
  "iso.standards.title": "ISO-Managementsysteme",
  "iso.standards.subtitle": "Bereiten Sie Ihr Unternehmen mit Managementsystemen nach internationalen Standards auf die Zukunft vor",
  "benefits.title": "Vorteile:",

  // Certificate Showcase
  "showcase.badge": "Internationale Zertifikate",
  "showcase.title": "Weltweit Anerkannte Zertifizierungsstandards",
  "showcase.description": "Bringen Sie Ihr Unternehmen mit unseren international gültigen Zertifikaten, die GMP, HACCP, ISO und mehr abdecken, auf globale Standards.",
  "showcase.point1": "ISO 9001, ISO 14001, ISO 45001 und mehr",
  "showcase.point2": "HACCP, GMP Lebensmittelsicherheitszertifizierung",
  "showcase.point3": "SCC, GSTC internationale Zertifikate",
  "showcase.point4": "Schneller und zuverlässiger Zertifizierungsprozess",

  // Achievement Section
  "achievement.badge": "Unternehmenserfolge",
  "achievement.title": "Internationale Anerkennung und Erfolg",
  "achievement.subtitle": "Als IQ CERT sind wir mit unseren Erfolgen und Akkreditierungen auf internationaler Ebene ein vertrauenswürdiger Bezugspunkt in der Branche.",
  "achievement.caption": "IQ PCC-PYB Zertifikatszeremonie",
  "achievement.description": "Unsere von internationalen Akkreditierungsorganisationen genehmigte Zertifizierungskompetenz ermöglicht es uns, unseren Kunden höchste Qualitätssicherung zu bieten.",
  "achievement.caption2": "Zengezur Universität Zertifikatszeremonie",
  "achievement.description2": "Bei der im Rahmen unserer internationalen Zusammenarbeit durchgeführten Zertifikatszeremonie wurden den Teilnehmern von IQ CERT genehmigte Zertifikate überreicht.",
  "achievement.caption3": "ULAK Zusammenarbeit und Lösungspartnerschaft",
  "achievement.description3": "Durch unsere strategische Zusammenarbeit mit ULAK-Generaldirektor Fatih Sinan Yılmaz verbessern wir unsere Servicequalität in internationalen Akkreditierungsstandards.",
  "achievement.stat1": "Ländergültigkeit",
  "achievement.stat2": "Ausgestellte Zertifikate",
  "achievement.stat3": "Jahre Erfahrung",
  "achievement.stat4": "Kundenzufriedenheit",

  "services.teknik.title": "Technische Kontrollen",
  "services.teknik.subtitle": "Aufzug-, Rolltreppe- und technische Gerätekontrollen",
  "services.teknik.description": "Wir bieten regelmäßige Kontroll- und Prüfdienstleistungen für den sicheren Betrieb technischer Geräte.",
  "services.teknik.elevator": "Aufzug-Periodenkontrolle",
  "services.teknik.escalator": "Rolltreppe-Periodenkontrolle",
  "services.teknik.photovoltaic": "Photovoltaik-Kontrollen",
  "services.teknik.equipment": "Arbeitsgeräte-Kontrollen",
  "services.denetim.title": "Audit- und Überwachungsdienstleistungen",
  "services.denetim.subtitle": "Vorlade-Überwachung, Zweitparteien-Audit und Hygienekontrolle",
  "services.denetim.description": "Wir bieten umfassende Audit- und Überwachungsdienstleistungen für Produktqualität und Prozesssicherheit.",
  "services.denetim.preloading": "Vorlade-Überwachung",
  "services.denetim.secondparty": "Zweitparteien-Audit",
  "services.denetim.hygiene": "Hygiene und Sanitation",
  "services.enerji.title": "Energieeffizienz",
  "services.enerji.subtitle": "Energieausweis, Studie und Beratungsdienstleistungen",
  "services.enerji.description": "Wir bieten Expertenberatung und Zertifizierungsdienstleistungen zu Energieeinsparung und -effizienz.",
  "services.enerji.certificate": "Energieausweis",
  "services.enerji.study": "Energiestudie",
  "services.enerji.consulting": "Energieeffizienz-Beratung",
  "services.enerji.zerowaste": "Null-Abfall-Prozessmanagement",
  "services.ozel.title": "Spezielle Audits",
  "services.ozel.subtitle": "Schul-, Grüngebäude-, Hotel- und Sportsicherheitsaudits",
  "services.ozel.description": "Wir bieten Sicherheits- und Qualitätsaudit-Dienstleistungen für spezielle Sektoren.",
  "services.ozel.school": "Schulsicherheit",
  "services.ozel.green": "Grünes Gebäude",
  "services.ozel.hotel": "Hotel-Audits",
  "services.ozel.sports": "Sportsicherheit"
};

export default de;
